/**
 * Copyright © 2014 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 21.01.14, 13:28
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */
export class IncentiveVO {
    public bookmarkUsed: boolean;

    public toString(): string {
        return "bookmarkUsed: " + this.bookmarkUsed;
    }
}
